<template>
   <v-dialog
   v-model="openDialog"
    max-width="1000px"
  >
    <v-card>
      <v-card-title class="title-card">
        <span class="text-h5">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form
            ref="form"
            v-model="valid"
          >
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.nome"
                required
                :rules="nameRules"
                label="Nome"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="121"
              md="6"
            >
              <v-text-field
                v-model="obj.CPF"
                v-mask="'###.###.###-##'"
                label="CPF"
                required
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="12"
              md="6"
            >
              <v-text-field
                v-model="obj.chave_pix"
                required
                :rules="nameRules"
                label="Chave Pix"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="12"
              md="6"
            >
              <v-text-field
                v-model="obj.salario"
                required
                :rules="nameRules"
                label="Salário"
                outlined
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="12"
              md="6"
            >
              <v-text-field
                v-model="obj.telefone"
                v-mask="'(##)#####-####'"
                required
                :rules="nameRules"
                label="Telefone"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
            >
              <v-checkbox
                v-model="obj.isInativo"
                label="Inativo?"
              ></v-checkbox>
            </v-col>
          </v-row>
          <h2 class="mt-4">Documentos</h2>
          <v-divider></v-divider>
          <v-row class="mt-2">
            <v-col
              cols="3"
              sm="12"
              md="3"
            >
              <v-text-field
                v-model="obj.rg"
                label="RG"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="12"
              md="3"
            >
              <v-text-field
                v-model="obj.cnh"
                label="CNH"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="12"
              md="3"
            >
              <v-text-field
                v-model="obj.reservista"
                label="Reservista"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="12"
              md="3"
            >
              <v-text-field
                v-model="obj.ctps"
                label="CTPS"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="12"
              md="3"
            >
              <v-text-field
                v-model="obj.pis"
                label="PIS"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="12"
              md="3"
            >
              <v-text-field
                v-model="obj.titulo_eleitor"
                label="Titulo de eleitor"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="12"
              md="3"
            >
              <v-select
                v-model="obj.estado_civil"
                :items="estadosCivis"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Estado Civil"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="obj.link_google_drive"
                label="Link GOOGLE DRIVE"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0" v-if="obj.link_google_drive">
              <a :href="obj.link_google_drive" target="_blank">Pasta de arquivos - GOOGLE DRIVE</a>
            </v-col>
          </v-row>
         </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="closeModal"
        >
          Cancelar
        </v-btn>
        <v-btn
          dark
          color="primary"
          @click="save"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  props:{
        openDialog: Boolean
    },
    data () {
      return {
        valid:false,
        formTitle:'Novo cadastro',
        nameRules: [
          v => !!v || 'Campo requerido',
        ],
        estadosCivis:[
          {
            id:1,
            nome: "Solteiro(a)"
          },
          {
            id:2,
            nome: "Casado(a)"
          },
          {
            id:3,
            nome: "Divorciado(a)"
          },
          {
            id:4,
            nome: "Viúvo(a)"
          }
        ],
        dialog: false,
        obj: {
            chave_pix: '',
            nome:'',
            telefone:'',
            CPF:'',
            salario:'',
        },
      }
    },
    methods: {
      ...mapActions('pessoa', ['savePessoa']),
      async save() {
          this.$refs.form.validate()
          /* eslint-disable no-console */
          if (this.valid) {
            try {
                await this.savePessoa(this.obj)
                this.$emit('closeEditItem', true)
            } catch (error) {
                console.error(error);
            } finally {
                this.closeModal();
            }
          }
        },
      closeModal () {
        this.$emit('closeModal')
      },
      reset(){
        this.$refs.form.reset()
      },
    watch:{
      openDialog(){
        this.reset();
      }
    }
  }
}
</script>